export const LockIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7642_1087"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7642_1087)">
        <path
          d="M5.75061 17.5833C5.38061 17.5833 5.06575 17.4525 4.80603 17.1908C4.54645 16.929 4.41666 16.6133 4.41666 16.2436V8.75647C4.41666 8.38675 4.54749 8.07098 4.80916 7.80918C5.07096 7.54751 5.38673 7.41668 5.75645 7.41668H6.41666V5.41668C6.41666 4.42223 6.76575 3.5764 7.46395 2.87918C8.162 2.18195 9.00895 1.83334 10.0048 1.83334C11.0005 1.83334 11.8458 2.18195 12.5408 2.87918C13.2358 3.5764 13.5833 4.42223 13.5833 5.41668V7.41668H14.2435C14.6133 7.41668 14.929 7.54751 15.1908 7.80918C15.4525 8.07098 15.5833 8.38675 15.5833 8.75647V16.2436C15.5833 16.6133 15.4524 16.929 15.1904 17.1908C14.9286 17.4525 14.6127 17.5833 14.2427 17.5833H5.75061ZM5.75645 16.5H14.2435C14.3184 16.5 14.3799 16.476 14.4279 16.4279C14.476 16.3799 14.5 16.3184 14.5 16.2436V8.75647C14.5 8.68161 14.476 8.62015 14.4279 8.57209C14.3799 8.52404 14.3184 8.50001 14.2435 8.50001H5.75645C5.68159 8.50001 5.62013 8.52404 5.57207 8.57209C5.52402 8.62015 5.49999 8.68161 5.49999 8.75647V16.2436C5.49999 16.3184 5.52402 16.3799 5.57207 16.4279C5.62013 16.476 5.68159 16.5 5.75645 16.5ZM10.0044 13.7917C10.3646 13.7917 10.6693 13.6657 10.9183 13.4138C11.1672 13.162 11.2917 12.8559 11.2917 12.4956C11.2917 12.1354 11.1657 11.8307 10.9137 11.5817C10.6619 11.3328 10.3559 11.2083 9.99562 11.2083C9.63534 11.2083 9.33068 11.3343 9.08166 11.5863C8.83277 11.8381 8.70832 12.1441 8.70832 12.5044C8.70832 12.8647 8.8343 13.1693 9.08624 13.4183C9.33805 13.6672 9.64409 13.7917 10.0044 13.7917ZM7.49999 7.41668H12.5V5.41668C12.5 4.72223 12.2569 4.13195 11.7708 3.64584C11.2847 3.15973 10.6944 2.91668 9.99999 2.91668C9.30555 2.91668 8.71527 3.15973 8.22916 3.64584C7.74305 4.13195 7.49999 4.72223 7.49999 5.41668V7.41668Z"
          fill="#2E2E2E"
        />
      </g>
    </svg>
  );
};
